import React from 'react';
import { Routes, Route } from 'react-router-dom';
//
import Fatura from '../pages/Fatura';
import Nota from '../pages/Nota';
import NotFound from '../pages/NotFound';

export default function AllRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Fatura />} />
      <Route path="/nota" element={<Nota />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
